var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.platformQuery === 'android' || _vm.platformQuery === 'pc')?_c('Android'):_vm._e(),(_vm.platformQuery === 'ios')?_c('IOS'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }